// axios请求
import axios from "axios";
import qs from "qs";
import { session } from "./session";
import router from '@/router'
import { MessageBox} from 'element-ui'


const service = axios.create({
    // baseURL: process.env.BASE_API_COMMON,
    withCredentials: false, // send cookies when cross-domain requests
    timeout: 100000 // request timeout,
});

var loginTime = localStorage.getItem('loginTime');
const LOGIN_PAGE_NAME = "/api/login";
const REGIST_PAGE_NAME = "/Data/register.ashx?Action=GetVerificationCode";

const whitePageNameList = [LOGIN_PAGE_NAME, REGIST_PAGE_NAME]; // 路由白名单列表，名单中的跳过登录
// request interceptor
// 全局请求拦截

service.interceptors.request.use(
    config => {
      var rouleId = localStorage.getItem('rouleId');
        if((new Date().getTime() - parseInt(localStorage.getItem('loginTime')))>(3600000*24*2) && (!whitePageNameList.includes(config.url))) {
          // if (((new Date().getTime() - parseInt(localStorage.getItem('loginTime'))) > (3600000 * 24 * 2) || (localStorage.getItem('isFirstLoging') != 'isFirstLoging') ) && (!whitePageNameList.includes(config.url))) {
            MessageBox.alert('登录状态已过期，请重新登录', '系统提示', { confirmButtonText: '重新登录', cancelButtonText: '取消', type: 'warning' }).then(() => {
                session.removeSession();
                window.location.replace('/#/Login')
            }).catch(() => {
                session.removeSession();
                window.location.replace('/#/Login')
            });
        }
       if (config.url == "/Data/productBrand.ashx?Action=upload") {
            config.url = config.url + "&login_user_id=" + session.getUserId() + "&villages_id=" + session.getVillageId() + "&role_id=" + rouleId;
            config.headers["Content-Type"] = "multipart/form-data";
            config.headers["Access-Control-Allow-Origin"] = "*";
        } else if (config.url != "/api/login" && config.url.startsWith("/api/" )) {
            config.headers["X-UserId"] = session.getUserId();
            config.headers["X-VillageId"] = session.getVillageId();
            config.headers["x-RoleId"] = rouleId;
        }
        // 上传换请求头
        else if (config.url.startsWith("/Data/")) {
            config.headers["Content-Type"] = "application/x-www-form-urlencoded";
            config.url = config.url + "&login_user_id=" + session.getUserId() + "&villages_id=" + session.getVillageId() + "&role_id=" + rouleId;
            config.headers["Access-Control-Allow-Origin"] = "*";
            if (config.method === 'get' && config.params) {
                // 对查询参数进行 URL 编码
                const encodedParams = new URLSearchParams(JSON.parse(JSON.stringify(config.params)));
                // 将编码后的查询参数赋值给原先的params
                config.params = encodedParams;
              }
            config.data = qs.stringify(config.data,{ indices: false });
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// response interceptor
service.interceptors.response.use(
    /**
     * If you want to get http information such as headers or status
     * Please return  response => response
     */

    /**
     * Determine the request status by custom code
     * Here is just an example
     * You can also judge the status by HTTP Status Code
     */
    response => {
        const res = response.data;
        if (res.code == 101 && res.message == "登陆用户的公司信息有误！") {
            alert(res.message);
            // alert('登录失效');
            router.push({ name: "Login" });
        } else {
            // alert('登录失效');
            return res;
        }
    },
    error => {
        console.log(error); // for debug
        // Message({
        //   message: error.message,
        //   type: "error",
        //   duration: 5 * 1000,
        // });
        return Promise.reject(error);
    }
);
export const get = (url, params) => service.get(url, { params });
export const getQuery = (url, params) => service.get(url, { params });

export const post = (url, data) => service.post(url, data);

export const postQuery = (url, params) => service.request({url:url,method:"post",params});

// export const put = (url, data) => service.put(url, data);

// export const del = url => service.delete(url);

export default service;



// WEBPACK FOOTER //
// ./src/utils/service.js